export default "__VITE_ASSET__Mg_kkXhN__"